import React from "react";

const Privacy = () => {
  return (
    <main>
      <section className="">
        <div className="w-container  max-w-4xl pt-[4rem] xl:pt-[12rem]  mx-auto ">
          <div className="">
            <h3 className="font-lato-bold text-darkCyan">
              Privacy Policy – The Buddha Institute
            </h3>
            <h6 className="font-lato-bold  text-black py-3 text-base sm:text-lg">
              Effective Date: [Insert Date]
            </h6>
          </div>

          <div className="font-lato-regular text-base">
            <section className="blade-bottom-padding-sm">
              <p className=" text-black font-lato-regular text-base sm:text-lg">
                At{" "}
                <span className="font-lato-bold text-black">
                  The Buddha Institute
                </span>
                , we are committed to safeguarding your privacy and ensuring the
                security of your personal information. This Privacy Policy
                outlines how we collect, use, and protect your data when you
                interact with our website and services.
              </p>

              <h4 className="font-lato-bold  text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                1. Information We Collect
              </h4>
              <h6 className="text-black text-base sm:text-lg font-lato-regular py-1">
                We may collect the following information:
              </h6>
              <ul className="list-inside list-disc sm:ps-4">
                <li className="text-black text-base sm:text-lg">
                  <span className="text-black font-lato-bold">
                    Personal Details :
                  </span>{" "}
                  Name, email address, and any other information you voluntarily
                  provide.
                </li>
                <li className="text-black text-base sm:text-lg">
                  <span className="text-black font-lato-bold">
                    Communication Preferences :
                  </span>{" "}
                  Your preferences regarding the information you wish to receive
                  from us.
                </li>
                <li className="text-black  text-base sm:text-lg">
                  <span className="text-black font-lato-bold">
                    Usage Data :{" "}
                  </span>
                  Information about how you use our website, such as pages
                  visited and time spent on the site.
                </li>
              </ul>
              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                2. How We Use Your Information
              </h4>
              <h6 className="text-black font-lato-regular text-base sm:text-lg py-1">
                Your information is used to:
              </h6>
              <ul className=" list-inside list-disc sm:ps-4">
                <li className="text-black text-base sm:text-lg">
                  <span className="text-black font-lato-bold">
                    Provide Services:
                  </span>{" "}
                  Send newsletters, updates, and information about our programs
                  and events.
                </li>
                <li className="text-black  text-base sm:text-lg">
                  <span className="text-black font-lato-bold">
                    Improve Our Offerings:
                  </span>{" "}
                  Analyze website usage to enhance user experience.
                </li>
                <li className="text-black  text-base sm:text-lg">
                  {" "}
                  <span className="text-black font-lato-bold">
                    Communicate:
                  </span>{" "}
                  Respond to inquiries and provide support
                </li>
              </ul>
              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                We do not sell or rent your personal information to third
                parties.
              </h6>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                3. Newsletter Subscription
              </h4>
              <h6 className="text-black font-lato-regular py-1 text-base sm:text-lg">
                By subscribing to our newsletter:
              </h6>
              <ul className=" list-inside list-disc sm:ps-4">
                <li className="text-black  text-base sm:text-lg">
                  You consent to receive emails from us.
                </li>
                <li className="text-black  text-base sm:text-lg">
                  You can unsubscribe at any time by clicking the link in our
                  emails or contacting us directly [EMAIL ID]
                </li>
              </ul>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                4. Data Security
              </h4>
              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                We implement appropriate security measures to protect your
                personal information. However, no method of transmission over
                the internet is entirely secure.
              </h6>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">5. Your Rights</h4>
              <h6 className="text-black font-lato-regular py-1 text-base sm:text-lg">
                You have the right to:
              </h6>
              <ul className=" list-inside list-disc sm:ps-4">
                <li className="text-black text-base sm:text-lg ">
                  <span className="text-black font-lato-bold ">Access:</span>{" "}
                  Request a copy of the information we hold about you.
                </li>
                <li className="text-black  text-base sm:text-lg">
                  <span className="text-black font-lato-bold ">Correction:</span>{" "}
                  Request corrections to any inaccurate information.
                </li>
                <li className="text-black  text-base sm:text-lg">
                  <span className="text-black font-lato-bold ">Deletion:</span>{" "}
                  Request the deletion of your personal information.
                </li>
              </ul>
              <h6 className="text-black font-lato-regular py-1 text-base sm:text-lg">
                To exercise these rights, please contact us at [Insert Contact
                Email].
              </h6>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                6. Changes to This Policy
              </h4>
              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                We may update this Privacy Policy from time to time. Changes
                will be posted on this page with an updated effective date.
              </h6>
              <h4 className="text-black font-lato-bold pt-3 sm:pt-5 text-base sm:text-2xl">
                Terms & Conditions – The Buddha Institute Website & Newsletter
              </h4>
              <h6 className="py-3  text-black font-lato-bold text-base sm:text-lg">
                Effective Date: [Insert Date]
              </h6>
              <h6 className="text-black font-lato-regular py-1 text-base sm:text-lg">
                By accessing our website or subscribing to our newsletter, you
                agree to the following terms:
              </h6>
              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                1. Use of Website
              </h4>
              <ul className=" list-inside list-disc sm:ps-4">
                <li className="text-black text-base sm:text-lg">
                  Content on our website is for informational purposes only.
                </li>
                <li className="text-black text-base sm:text-lg">
                  You may not use our content for commercial purposes without
                  our written consent.
                </li>
              </ul>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                2. Intellectual Property
              </h4>
              <ul className=" list-inside list-disc sm:ps-4">
                <li className="text-black text-base sm:text-lg">
                  All content on this website is the property of The Buddha
                  Institute unless otherwise stated.
                </li>
                <li className="text-black text-base sm:text-lg">
                  Unauthorized use of our content may violate copyright laws.
                </li>
              </ul>
              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                3. External Links
              </h4>

              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                Our website may contain links to external websites. We are not
                responsible for the content or privacy practices of these sites.
              </h6>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                4. Limitation of Liability
              </h4>

              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                The Buddha Institute is not liable for any damages arising from
                the use of our website or newsletter.
              </h6>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">
                5. Changes to Terms
              </h4>

              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                We may revise these Terms & Conditions at any time. Continued
                use of our website signifies your acceptance of any changes.
              </h6>

              <h4 className="font-lato-bold text-black pt-3 sm:pt-5 text-base sm:text-2xl">6. Contact Us</h4>

              <h6 className="text-black font-lato-regular text-base sm:text-lg">
                For any questions regarding these Terms & Conditions, please
                contact us at [Insert Contact Email].
              </h6>
            </section>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Privacy;
